import Container from "@base/Container/Container";

export default Container;
